const SECOND_FACTOR_REFUSAL = /^SECOND_FACTOR_/

/**
 * Whether a response means the sign-in is over. A 401 does — except when it is the server refusing a
 * second factor proof (a wrong code on the account page, a cancelled key): the person is still
 * signed in and must stay so.
 */
export const isSessionExpired = (status: number | undefined, data: unknown): boolean => {
  if (status !== 401) {
    return false
  }

  const errorCode = (data as { errorCode?: unknown } | null | undefined)?.errorCode

  return !(typeof errorCode === 'string' && SECOND_FACTOR_REFUSAL.test(errorCode))
}
